export enum DerivationStatus {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  FINISHED = 'FINISHED',
  FINISHED_WITH_CASE = 'FINISHED_WITH_CASE',
}
